import Typography from '@ui/typography'
import { createContext, useContext } from 'react'
import { View } from 'react-native'
import cn from '@ui/utils/cn'

const NestedContext = createContext(false)

export default function DebugSection({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) {
  const nested = useContext(NestedContext)
  return (
    <NestedContext.Provider value={true}>
      <View className={cn(!nested && 'p-4')}>
        <View
          className={cn(
            !nested && 'overflow-hidden rounded-md border border-black/25'
          )}
        >
          <View className={cn('p-4', !nested && 'bg-slate-50')}>
            {!!title && (
              <Typography variant={nested ? 'XSB' : 'SMB'}>{title}</Typography>
            )}
          </View>
          <View className={cn('gap-4 p-4')}>{children}</View>
        </View>
      </View>
    </NestedContext.Provider>
  )
}
